var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.933,
    height: 17.771,
    viewBox: "0 0 16.933 17.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-add-svgrepo-com",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6880",
    "data-name": "Path 6880",
    d: "M17.182,7.872l.389-.389A1.649,1.649,0,0,1,19.9,9.815l-.389.389M17.182,7.872A2.748,2.748,0,0,0,19.514,10.2M17.182,7.872,13.61,11.444a5.733,5.733,0,0,0-.467.5,2.754,2.754,0,0,0-.314.508,5.724,5.724,0,0,0-.235.64l-.346,1.039-.112.336M19.514,10.2l-3.573,3.573a5.733,5.733,0,0,1-.5.467,2.754,2.754,0,0,1-.508.314,5.724,5.724,0,0,1-.64.235l-1.039.346-.336.112m0,0-.336.112a.445.445,0,0,1-.562-.562l.112-.336m.787.787-.787-.787",
    transform: "translate(-4.453 -2.807)",
    fill: "none",
    stroke: "#36abef",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6881",
    "data-name": "Path 6881",
    d: "M8,13h2.1",
    transform: "translate(-3.807 -3.776)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6882",
    "data-name": "Path 6882",
    d: "M8,9h5.451",
    transform: "translate(-3.807 -3.13)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6883",
    "data-name": "Path 6883",
    d: "M8,17H9.258",
    transform: "translate(-3.807 -4.421)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6884",
    "data-name": "Path 6884",
    d: "M17.112,2.982C16.129,2,14.548,2,11.386,2H9.709c-3.162,0-4.744,0-5.726.982S3,5.546,3,8.709v3.354c0,3.162,0,4.744.982,5.726s2.564.982,5.726.982h1.677c3.162,0,4.744,0,5.726-.982.791-.791.945-1.97.975-4.049",
    transform: "translate(-3 -2)",
    fill: "none",
    stroke: "#36abef",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDoc);
export default __webpack_public_path__ + "static/media/menuDoc.74714eb4c54bafcd65302d47abf02568.svg";
export { ForwardRef as ReactComponent };